(() => {
  'use strict';
  const root = document.documentElement;
  if (document.querySelector('.jl-mobile-tools')) return;
  const chat = document.querySelector('[data-chat-launch]');
  if (!chat) return;
  const mobile = window.matchMedia('(max-width:600px)');
  const form = 'omnisend-form-6a96129a84399ee8ed76804f';
  const overlays = '.jl-drawer.is-open,.jl-search-overlay.is-open,.jl-lightbox.is-open,.dialog-panel:not([hidden]),dialog[open],.' + form + '-container';
  const dock = document.createElement('div');
  dock.className = 'jl-mobile-tools';
  const music = document.createElement('button');
  music.type = 'button'; music.className = 'jl-mobile-tools__music';
  music.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 18V5l11-2v13M9 8l11-2"/><ellipse cx="6" cy="18" rx="3" ry="2.5"/><ellipse cx="17" cy="16" rx="3" ry="2.5"/></svg><span>Music</span>';
  music.setAttribute('aria-controls','jl-audio-player');
  music.setAttribute('aria-expanded','false');
  dock.append(music); document.body.append(dock);
  chat.setAttribute('aria-label',chat.textContent.trim());
  let expanded = false, scheduled = false;
  const audioBox = () => document.querySelector('[data-jl-audio]');
  const visible = element => {
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return !element.hidden && style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  };
  const property = (element,name,value) => {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name,value);
  };
  function collapse(focus = false) {
    expanded = false; root.classList.remove('jl-mobile-tools-music-open');
    music.setAttribute('aria-expanded','false');
    if (focus && mobile.matches) music.focus({preventScroll:true});
  }
  function sync() {
    scheduled = false;
    root.classList.toggle('jl-mobile-tools-ready',mobile.matches);
    if (!mobile.matches) { if (expanded) collapse(); return; }
    property(root,'--jl-tools-width',`${document.documentElement.clientWidth}px`);
    const box = audioBox();
    const pdf = document.getElementById(form + '-teaser-btn');
    const teaser = pdf?.closest('.' + form + '-teaser');
    const pdfAvailable = Boolean(teaser && !teaser.hidden && teaser.style.display !== 'none');
    if (pdfAvailable) {
      if (!teaser.classList.contains('jl-mobile-tools__pdf')) teaser.classList.add('jl-mobile-tools__pdf');
      if (!pdf.parentElement.classList.contains('jl-mobile-tools__pdf-inner')) pdf.parentElement.classList.add('jl-mobile-tools__pdf-inner');
    } else if (teaser?.classList.contains('jl-mobile-tools__pdf')) {
      teaser.classList.remove('jl-mobile-tools__pdf');
      pdf.parentElement.classList.remove('jl-mobile-tools__pdf-inner');
    }
    const entries = [pdfAvailable ? teaser : null,box ? music : null,chat].filter(Boolean);
    property(root,'--jl-tools-count',String(entries.length));
    entries.forEach((element,index) => property(element,'--jl-tool-index',String(index)));
    if (music.hidden !== !box) music.hidden = !box;
    const give = document.querySelector('[data-kenya-mobile-give]');
    const rect = give?.getBoundingClientRect();
    const giveHeight = give && visible(give) && rect.bottom > 0 && rect.top < window.innerHeight ? Math.max(0,window.innerHeight - rect.top) : 0;
    // The give bar already includes the bottom safe area; do not add it twice.
    property(root,'--jl-tools-bottom',giveHeight ? `${giveHeight + 8}px` : 'max(10px, env(safe-area-inset-bottom))');
    const active = document.activeElement;
    const typing = Boolean(active?.matches('input,textarea,select,[contenteditable="true"]') && !active.closest('[data-jl-audio]'));
    const blocked = typing || [...document.querySelectorAll(overlays)].some(visible);
    root.classList.toggle('jl-mobile-tools-hidden',blocked);
    if ((blocked || box?.hidden) && expanded) collapse();
    const playing = box?.classList.contains('is-playing');
    music.classList.toggle('is-playing',Boolean(playing));
    const label = playing ? 'Music controls, playing' : 'Music controls';
    if (music.getAttribute('aria-label') !== label) music.setAttribute('aria-label',label);
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(sync); } }
  music.addEventListener('click',() => {
    const box = audioBox(); if (!box) return;
    if (expanded) return collapse();
    box.hidden = false; expanded = true;
    root.classList.add('jl-mobile-tools-music-open'); music.setAttribute('aria-expanded','true');
    box.querySelector('[data-jl-audio-toggle]')?.focus({preventScroll:true});
  });
  document.addEventListener('click',event => {
    if (!expanded) return;
    if (event.target.closest('[data-jl-audio-close]')) collapse(true);
    else if (!event.target.closest('[data-jl-audio],.jl-mobile-tools__music')) collapse();
  });
  document.addEventListener('keydown',event => {
    if (event.key === 'Escape' && expanded) { event.preventDefault(); collapse(true); }
  });
  document.addEventListener('focusin',schedule);
  document.addEventListener('focusout',schedule);
  window.addEventListener('resize',schedule);
  window.visualViewport?.addEventListener('resize',schedule);
  mobile.addEventListener('change',schedule);
  new MutationObserver(schedule).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','hidden','open','style','aria-hidden']});
  sync();
})();
